function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/*! License details at fancyapps.com/license */
import { isPlainObject as t } from "../utils/isPlainObject.js";
import { isString as e } from "../utils/isString.js";
import { replaceAll as o } from "../utils/replaceAll.js";
import { Panzoom as n, PanzoomAction as i } from "../panzoom/panzoom.js";
var a = {
    tpl: function tpl(t) {
      return "<img class=\"f-panzoom__content\" \n    ".concat(t.srcset ? 'data-lazy-srcset="{{srcset}}"' : "", " \n    ").concat(t.sizes ? 'data-lazy-sizes="{{sizes}}"' : "", " \n    data-lazy-src=\"{{src}}\" alt=\"{{alt}}\" />");
    }
  },
  s = function s() {
    var s;
    function l(e, o) {
      var n = null == s ? void 0 : s.getOptions().Zoomable;
      var i = (t(n) ? Object.assign(Object.assign({}, a), n) : a)[e];
      return i && "function" == typeof i && o ? i(o) : i;
    }
    function c() {
      s && (s.on("addSlide", u), s.on("removeSlide", f), s.on("attachSlideEl", m), s.on("click", d), s.on("change", r));
    }
    function r() {
      g();
    }
    function d(t, e) {
      var o = e.target;
      o && !e.defaultPrevented && o.dataset.panzoomAction && p(o.dataset.panzoomAction);
    }
    function u(t, i) {
      if (!s) return;
      var a = i.el;
      if (!a) return;
      var c = i.src || i.lazySrc || "",
        r = i.alt || i.caption || "Image #".concat(i.index),
        d = i.srcset || i.lazySrcset || "",
        u = i.sizes || i.lazySizes || "";
      if (c && e(c) && !i.html && (!i.type || "image" === i.type)) {
        i.type = "image", i.thumbSrc = i.thumbSrc || c;
        var _t = l("tpl", i);
        _t = o(_t, "{{src}}", c + ""), _t = o(_t, "{{alt}}", r + ""), _t = o(_t, "{{srcset}}", d + ""), _t = o(_t, "{{sizes}}", u + ""), a.insertAdjacentHTML("afterbegin", _t);
      }
      if (!a.querySelector(".f-panzoom__content")) return;
      var f = i.width && "auto" !== i.width ? parseFloat(i.width + "") : "auto",
        m = i.height && "auto" !== i.height ? parseFloat(i.height + "") : "auto",
        p = n(a, Object.assign({
          width: f,
          height: m,
          classes: {
            container: "f-zoomable"
          },
          event: function event() {
            return null == s ? void 0 : s.getLastMouseMove();
          },
          spinnerTpl: function spinnerTpl() {
            return (null == s ? void 0 : s.getOption("spinnerTpl")) || "";
          }
        }, l("Panzoom")));
      p.on("*", function (t, e) {
        var _s;
        for (var _len = arguments.length, o = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
          o[_key - 2] = arguments[_key];
        }
        s && ("loading" === e && (i.state = 0), "loaded" === e && (i.state = 1), "error" === e && (i.state = 2, null == s || s.showError(i, "{{IMAGE_ERROR}}")), (_s = s).emit.apply(_s, ["panzoom:".concat(e), i].concat(o)), "ready" === e && s.emit("contentReady", i), i.index === (null == s ? void 0 : s.getPageIndex()) && g());
      }), i.panzoomRef = p;
    }
    function f(t, e) {
      e.panzoomRef && (e.panzoomRef.destroy(), e.panzoomRef = void 0);
    }
    function m(t, e) {
      var o = e.panzoomRef;
      if (o) switch (o.getState()) {
        case 0:
          o.init();
          break;
        case 3:
          o.execute(i.ZoomTo, Object.assign(Object.assign({}, o.getStartPosition()), {
            velocity: 0
          }));
      }
    }
    function g() {
      var t;
      var e = null == s ? void 0 : s.getContainer();
      if (!e) return;
      var o = null === (t = null == s ? void 0 : s.getPage()) || void 0 === t ? void 0 : t.slides[0].panzoomRef,
        n = (null == o ? void 0 : o.canZoomIn()) || !1,
        a = (null == o ? void 0 : o.canZoomOut()) || !1,
        l = (null == o ? void 0 : o.isFullsize()) || !1,
        c = !o || 3 !== (null == o ? void 0 : o.getState());
      var _iterator = _createForOfIteratorHelper((null == e ? void 0 : e.querySelectorAll("[data-panzoom-action]")) || []),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _t2 = _step.value;
          var _e = _t2.dataset.panzoomAction;
          var _o = !1;
          if (c) _o = !0;else switch (e) {
            case i.ZoomIn:
              n || (_o = !0);
              break;
            case i.ZoomOut:
              a || (_o = !0);
              break;
            case i.ToggleFull:
              n || a || (_o = !0);
              var _e2 = _t2.querySelector("g");
              _e2 && (_e2.style.display = l ? "none" : "");
              break;
            case i.ToggleCover:
            case i.ToggleMax:
              n || a || (_o = !0);
          }
          _o ? (_t2.setAttribute("aria-disabled", ""), _t2.setAttribute("tabindex", "-1")) : (_t2.removeAttribute("aria-disabled"), _t2.removeAttribute("tabindex"));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    function p(t) {
      var _o2;
      var o;
      for (var _len2 = arguments.length, e = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        e[_key2 - 1] = arguments[_key2];
      }
      null === (o = null == s ? void 0 : s.getPage().slides[0].panzoomRef) || void 0 === o || (_o2 = o).execute.apply(_o2, [t].concat(e));
    }
    return {
      init: function init(t) {
        s = t, !1 !== s.getOptions().Zoomable && s.on("initPlugins", c);
      },
      destroy: function destroy() {
        if (s) {
          s.off("addSlide", u), s.off("removeSlide", f), s.off("attachSlideEl", m), s.off("click", d), s.off("change", r);
          var _iterator2 = _createForOfIteratorHelper(s.getSlides()),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var _t3 = _step2.value;
              f(0, _t3);
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
        s = void 0;
      },
      execute: p
    };
  };
export { s as Zoomable };